/* eslint-disable import/prefer-default-export */

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    width: '100% ',
    margin: '10px',
    alignContent: 'center',
    backgroundColor: theme.palette.background.paper,
  },
  fieldListHeader: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginBottom: '15px',
  },
  fieldList: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(0.5),
      width: '21em',
    },
    '& > p': {
      alignItems: 'left',
      width: '20px',
    },
  },
  button: {
    justifyContent: 'flex-start',
    margin: theme.spacing(0.5),
  },
  buttonSalesManago: {
    justifyContent: 'flex-end',
    right: '2px',
    margin: theme.spacing(1),
    '& > *': {
      margin: theme.spacing(0.5),
      //  width: '21em',
    },
  },
  chips: {
    display: 'inline-flex',
    justifyContent: 'center',
    margin: theme.spacing(0.5),
  },
  disabledButton: {
    background: '#1B1B1B',
    ':disabled': {
      color: 'grey',
    },
  },
  slider: {
    margin: '20px',
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'green',
    },
  },
  con: {
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(2),
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'green',
    },
  },
}));

